import { useContext } from 'react';
import { createContext } from 'react';

import { DisclosureLayoutGroupProps } from '../@types/DisclosureLayoutGroupProps';

export const DisclosureLayoutGroupContext = createContext<DisclosureLayoutGroupProps>({} as DisclosureLayoutGroupProps);

DisclosureLayoutGroupContext.displayName = 'DisclosureLayoutGroup';

const DisclosureLayoutGroupProvider = (props: DisclosureLayoutGroupProps) => (
	<DisclosureLayoutGroupContext.Provider value={props}>{props.children}</DisclosureLayoutGroupContext.Provider>
);

export const useDisclosureLayoutGroup = () => {
	const context = useContext(DisclosureLayoutGroupContext);

	return context;
};

export default DisclosureLayoutGroupProvider;
